export const ageFilter = [
  { label: '<20', value: '<20' },
  { label: '20-29', value: '20-29' },
  { label: '30-39', value: '30-39' },
  { label: '40-49', value: '40-49' },
  { label: '50-59', value: '50-59' },
  { label: '60-69', value: '60-69' },
  { label: '70-79', value: '70-79' },
  { label: '80-89', value: '80-89' },
  { label: '90+', value: '90+' },
];

export const dateFilter = [
  { label: 'Today', value: '1' },
  { label: 'Last 7 days', value: '7' },
  { label: 'Last 30 days', value: '30' },
  { label: 'Last 90 days', value: '90' },
  { label: 'Custom', value: 'custom' },
];

export const genderFilter = [
  { label: 'Female', value: 'female' },
  { label: 'Male', value: 'male' },
];
export const participantFilter = [
  { label: 'All', value: 'all'},
  { label: 'Patient', value: 'patient' },
  { label: 'Family Member or Carer', value: 'other' },
];

export const genderIdentityFilter = [
  { label: 'Man (including trans man)', value: 'man' },
  { label: 'Woman (including trans woman)', value: 'woman' },
  { label: 'Non-binary', value: 'non_binary' },
  { label: 'In another way', value: 'other' },
  { label: 'Prefer not to say', value: 'undisclosed' },
];

export const travelFilter = [
  { label: 'Drive my own vehicle (car/motorbike)', value: 'own_vehicle' },
  { label: 'Public transport (bus, train, etc)', value: 'public' },
  { label: 'Taxi', value: 'taxi' },
  { label: 'Family / friend drives me', value: 'relative' },
  { label: 'Hospital transport service', value: 'hospital_transport' },
  { label: 'Others', value: 'others' },
];

export const pathwayTimeFilter = [
  { label: '1 day', value: '1' },
  { label: '7 days', value: '7' },
  { label: '20 days', value: '20' },
  { label: '30 days', value: '30' },
];

export const hospitalsVisitedFiter = [
  { label: '1', value: '1' },
  { label: '2', value: '2' },
  { label: '3', value: '3' },
  { label: '4', value: '4' },
  { label: '5', value: '5' },
  { label: '6+', value: '6+' },
  { label: `I'm not sure`, value: 'unsure' },
];

export const testsFilter = [
  { label: 'CT scan of the lungs', value: 'lungs_ct' },
  { label: 'PET scan', value: 'pet_scan' },
  { label: 'Brain scan', value: 'brain_scan' },
  { label: 'Bronchoscopy', value: 'bronchoscopy' },
  { label: 'EBUS', value: 'ebus' },
  { label: 'Lung biopsy', value: 'lung_biopsy' },
  {
    label: 'CT scan or MRI scan of a different part of the body',
    value: 'other_ct_or_mri',
  },
  { label: 'A different kind of biopsy', value: 'other_biopsy' },
  { label: 'Breathing tests', value: 'breathing' },
  { label: 'Heart scan', value: 'heart_scan' },
  { label: 'Exercise test', value: 'exercise' },
  { label: `I\'m not sure`, value: 'unsure' },
  { label: 'Others', value: 'others' },
];

export const sexualOrientationFilter = [
  { label: 'Straight/Heterosexual', value: 'heterosexual' },
  { label: 'Homosexual, lesbian, gay', value: 'homosexual' },
  { label: 'Bisexual', value: 'bisexual' },
  { label: 'Prefer not to say', value: 'undisclosed' },
];

export const liveAloneFilter = [
  { label: 'Yes', value: 'yes' },
  { label: 'No', value: 'no' },
  { label: 'Prefer not to say', value: 'undisclosed' },
];

export const ethnicityFilter = [
  { label: 'White', value: 'white' },
  { label: 'White and Black Caribbean', value: 'white_black_caribbean' },
  { label: 'White and Black African', value: 'white_black_african' },
  { label: 'White and Asian', value: 'white_asian' },
  { label: 'Any other Mixed / Multiple ethnic background', value: 'mixed' },
  { label: 'Asian - Indian', value: 'asian_indian' },
  { label: 'Asian - Pakistani', value: 'asian_pakistani' },
  { label: 'Asian - Bangladeshi', value: 'asian_bangladeshi' },
  { label: 'Asian - Chinese', value: 'asian_chinese' },
  { label: 'Asian - Any other Asian background', value: 'asian_other' },
  { label: 'African', value: 'african' },
  { label: 'Caribbean', value: 'caribbean' },
  {
    label: 'Other Black / African / Caribbean background',
    value: 'black_african_caribbean_other',
  },
  { label: 'Arab', value: 'arab' },
  { label: 'Any other ethnic group', value: 'other' },
];

export const serviceTypeFilter = [
  { label: 'Wythenshawe Hospital: RAPID hub (Morning visit with same day CT scan & clinic appointment)', value: 'wythenshawe_hospital_rapid_hub_morning' },
  { label: 'Wythenshawe Hospital: Post-MDT clinic (Test results clinic after \'MDT\' meeting)', value: 'wythenshawe_hospital_post_mdt_clinic' },
  { label: 'Wythenshawe Hospital: Survivorship clinic (Follow-up clinic after treatment)', value: 'wythenshawe_hospital_survivorship_clinic' },
  { label: 'Wythenshawe Hospital: Pleural clinic', value: 'wythenshawe_hospital_pleural_clinic' },
  { label: 'Wythenshawe Hospital: Pleural procedure list', value: 'wythenshawe_hospital_pleural_procedure_list'},
  { label: 'Wythenshawe Hospital: RAPID hub: other', value: 'wythenshawe_hospital_rapid_hub_other' },
  { label: 'Wythenshawe Hospital: Bronchoscopy procedure', value: 'wythenshawe_hospital_bronchoscopy_procedure' },
  { label: 'Wythenshawe Hospital: Robotic (ION) bronchoscopy', value: 'wythenshawe_hospital_robotic_bronchoscopy' },
  { label: 'Wythenshawe Hospital: Lung biopsy procedure', value: 'wythenshawe_hospital_lung_biopsy_procedure' },
  { label: 'Wythenshawe Hospital: Oncology clinic - first appointment as a new patient', value: 'wythenshawe_hospital_oncology_clinic_first' },
  { label: 'Wythenshawe Hospital: Oncology clinic - follow-up appointment', value: 'wythenshawe_hospital_oncology_clinic_follow_up' },
  { label: 'Wythenshawe Hospital: Cecelia Unit – treatment visit', value: 'wythenshawe_hospital_cecelia_unit' },
  { label: 'Wythenshawe Hospital: Lung Surgery: first appointment as a new patient', value: 'wythenshawe_hospital_lung_surgery_clinic_first' },
  { label: 'Wythenshawe Hospital: Lung Surgery - follow-up appointment', value: 'wythenshawe_hospital_lung_surgery_clinic_follow_up' },
  { label: 'Wythenshawe Hospital: One-stop lung cancer clinic', value: 'wythenshawe_hospital_one_stop_lung_cancer' },
  { label: 'Wythenshawe Hospital: Care of the Dying', value: 'wythenshawe_hospital_care_of_the_dying' },
  { label: 'Wythenshawe Hospital: CURE team support (specialist stop smoking service)', value: 'wythenshawe_hospital_cure_team_support' },
  { label: 'Manchester Royal Infirmary: RAPID Clinic', value: 'manchester_royal_infirmary_rapid_clinic' },
  { label: 'Manchester Royal Infirmary: Nurse-led survivorship clinic (Follow-up clinic after treatment)', value: 'manchester_royal_infirmary_nurse_led_survivorship_clinic' },
  { label: 'Manchester Royal Infirmary: Follow-up clinic', value: 'manchester_royal_infirmary_follow_up_clinic' },
  { label: 'Manchester Royal Infirmary: New patient clinic', value: 'manchester_royal_infirmary_new_patient_clinic' },
  { label: 'Manchester Royal Infirmary: Nodule service', value: 'manchester_royal_infirmary_nodule_service' },
  { label: 'Manchester Royal Infirmary: Pleural clinic', value: 'manchester_royal_infirmary_pleural_clinic' },
  { label: 'Manchester Royal Infirmary: Pleural procedure list', value: 'manchester_royal_infirmary_pleural_procedure_list' },
  { label: 'Manchester Royal Infirmary: Bronchoscopy Procedure', value: 'manchester_royal_infirmary_bronchoscopy_procedure' },
  { label: 'Manchester Royal Infirmary: Care of the Dying', value: 'manchester_royal_infirmary_care_of_the_dying' },
  { label: 'Manchester Royal Infirmary: CURE team support (specialist stop smoking service)', value: 'manchester_royal_infirmary_cure_team_support' },
  { label: 'North Manchester General Hospital: Lung cancer clinic (Rapid Access Clinic)', value: 'north_manchester_general_hospital_lung_cancer_clinic' },
  { label: 'North Manchester General Hospital: Virtual lung cancer clinic', value: 'north_manchester_general_hospital_virtual_lung_cancer_clinic' },
  { label: 'North Manchester General Hospital: Survivorship clinic (Follow-up clinic after treatment)', value: 'north_manchester_general_hospital_survivorship_clinic' },
  { label: 'North Manchester General Hospital: Bronchoscopy procedure', value: 'north_manchester_general_hospital_bronchoscopy_procedure' },
  { label: 'North Manchester General Hospital: Pleural clinic', value: 'north_manchester_general_hospital_pleural_clinic' },
  { label: 'North Manchester General Hospital: Pleural procedure list', value: 'north_manchester_general_hospital_pleural_procedure_list' },
  { label: 'North Manchester General Hospital: Nodule service', value: 'north_manchester_general_hospital_nodule_service' },
  { label: 'North Manchester General Hospital: Care of the Dying', value: 'north_manchester_general_hospital_care_of_the_dying' },
  { label: 'North Manchester General Hospital: CURE team support (specialist stop smoking service)', value: 'north_manchester_general_hospital_cure_team_support' },
  { label: 'Community Lung health Check Service', value: 'community_lung_health_check_service' },
];

export const languagesOptions = [
  { value: 'en', name: 'English' },
  { value: 'ar', name: 'Arabic' },
  { value: 'bn', name: 'Bengali' },
  { value: 'zh-hant', name: 'Cantonese' },
  { value: 'fa', name: 'Farsi' },
  { value: 'hi', name: 'Gujarati' },
  { value: 'pl', name: 'Polish' },
  { value: 'pa', name: 'Punjabi' },
  { value: 'ro', name: 'Romanian' },
  { value: 'ur', name: 'Urdu' },
];


